<template>


  <v-card elevation="5" outlined shaped>
    
    <v-dialog v-model="carreraModal" max-width="600" class="text-cenet">
      <v-card elevation="5" outlined shaped>
        <v-card-title>
          <span>
            <h5>CARRERA</h5>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>


              <v-col cols="12">
                <v-data-table :headers="headersCarrera" 
                :items="datosCarrera" 
                @click:row="($event, {item})=>seleccionarCarrera(item)"
                :items-per-page="5" class="elevation-1" hide-default-footer disable-pagination
                  id="tableId">

                  <!--template #[`item.actions`]="{ item }">
                    <v-icon color="blue" small class="mr-2" @click="seleccionarCarrera(item)">
                      mdi-check-circle
                    </v-icon>
                  </template-->
                </v-data-table>


              </v-col>
              <v-col cols="10"> </v-col>
              <v-col cols="2">
                <v-btn class="mx-2" fab dark x-small color="#EE680B" @click="closeCarrera" style="float: right"
                  title="SALIR">
                  <v-icon dark> mdi-close-circle-outline </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="kardexModal" max-width="100" class="text-center">
      <v-card elevation="5" outlined shaped>
        <v-card-title>
       
          <header>
            <br />  
            <div id="logo" style="float:left;margin-left: 2%;            margin-right: 2%">
              <img
                src='data:image/png;base64,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' />

            </div>
            <br />  <br />
          </header>
          <span>
            <h5> &nbsp;&nbsp;&nbsp;ESTUDIANTE: &nbsp;{{ nombres }} {{ paterno }} {{ materno }}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;
              {{ carrera }} &nbsp; {{ gestion }} </h5>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>


              <v-col cols="12">
                <v-data-table :headers="headersKardex" :items="datosKardex" class="elevation-1" id="tableId">
                  <template #[`item.estado`]="{ item }">
                    <v-chip :color="getColorKardex(item.estado)" dark center-active  hide-default-footer
                    disable-pagination>
                      {{ item.estado }}
                    </v-chip>
                  </template>


                </v-data-table>

              </v-col>


              <v-col cols="12" md="8"> </v-col>
              <v-col cols="12" md="4">
                <v-toolbar dense shaped color="#002245">
                  <v-toolbar-title style="color:#ffffff">
                    <h6>OPCIONES</h6>
                  </v-toolbar-title>

                  <v-btn class="mx-2" fab dark x-small color="#EE680B" @click="imprimirKardex()" style="float: left"
                    title="IMPRIMIR KARDEX">
                    <v-icon dark> mdi-printer-outline </v-icon>
                  </v-btn>
                  <v-btn class="mx-2" fab dark x-small color="#EE680B" @click="closeKardex" style="float: left"
                    title="SALIR">
                    <v-icon dark> mdi-close-circle-outline </v-icon>
                  </v-btn>

                </v-toolbar>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>


    <VueHtml2pdf :show-layout="false" :float-layout="true" :enable-download="true" :preview-modal="false"
      :paginate-elements-by-height="200" filename="kardex" :pdf-quality="2" :manual-pagination="true" pdf-format="a4"
      pdf-orientation="landscape" ref="html2Pdf" useCORS="true" pdf-content-width="100%">
      <section slot="pdf-content">
        <div id="kardexEstudiante"
          style=" padding: 10px; font-family: Arial, sans-serif;  font-size: 8px ;margin-top: 20px;">


          
            <v-card-title>
              <header>
                <div id="logo" style="float:left;margin-left: 2%;            margin-right: 2%">
                  <img
                    src='data:image/png;base64,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' />

                </div>
               

              </header>
         
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>


                  <v-col cols="12">
                    <span>
                <h6 style="text-align: center; font-size: 12px;">ESTUDIANTE: {{ nombreCompleto }}</h6>
                  <h6 style="text-align: center;font-size: 12px;">{{ carrera }}</h6>

              </span>
                    <v-data-table :headers="headersKardex" :items="datosKardex" class="elevation-1" id="tableId"
                      footer-props.items-per-page-options="[-1]"  hide-default-footer disable-pagination>
                     
                    </v-data-table>
                  </v-col>

                </v-row>
              </v-container>
            </v-card-text>
           
            <br>
            <br>     
        
         <v-divider></v-divider>



          <!--p><b> &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;FUNCIONARIO: &nbsp;{{ nomus }}
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp;
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              FIRMA:</b></p-->




        </div>
      </section>
     



    </VueHtml2pdf>





    <div>
      <v-alert dense color="#EE680B" style="color: #ffffff">
        <h5>KARDEX</h5>
      </v-alert>
    </div>
    <div>
     
    </div>
    <v-container>
          <v-row>
         <v-col cols="12" md="4">
              <!--v-btn class="mx-2" fab dark x-small color="#EE680B" @click="showCarrera()" style="float: right"
                title="BUSCAR CARRERA">
                <v-icon dark> mdi-gesture-double-tap </v-icon>
              </v-btn-->
                 <v-btn 
             rounded
                   color="#002245"
                    class="ma-2 white--text"
                     @click="showCarrera()"
                    >
                  SELECCIONA TU  CARRERA
                    <v-icon
                    right
                   dark
                     large
                       >
                 mdi-school-outline
              </v-icon>
           </v-btn>
            </v-col>
            <v-col cols="12" md="4 ">
              <v-text-field v-model="carrera" label="CARRERA" disabled required></v-text-field>
            </v-col>
          </v-row>
        </v-container>        
    
    <v-card elevation="5" outlined shaped>
      <v-card-text>
        <v-row>
          <v-col cols="12">


            <v-data-table :headers="headersKardex" :items="datosKardex" :items-per-page="20" class="elevation-1"
              id="tableId"  hide-default-footer
              disable-pagination>
              <template #[`item.estado`]="{ item }">
                <v-chip :color="getColorKardex(item.estado)" dark center-active>
                  {{ item.estado }}
                </v-chip>
              </template>




              <template #[`item.actions`]="{ item }">

                <v-icon small class="mr-2" @click="showCompromiso(item)" title="IMPRIMIR KARDEX">
                  mdi-printer-outline
                </v-icon>

                <!--v-icon small class="mr-2" @click="seleccionarDelFormAcad(item)" title="ELIMINAR INFORMACION">
                              mdi-delete
                            </v-icon-->
              </template>
            </v-data-table>
            

          </v-col>




          <v-col cols="12" md="12"> 
            <v-btn 
             rounded
                   color="#EE680B"
                    class="ma-2 white--text"
                     @click="imprimirKardex()"
                    >
                  DESCARGAR KARDEX
                    <v-icon
                    right
                   dark
                     large
                       >
                 mdi-download-circle-outline
              </v-icon>
           </v-btn>

          </v-col>
          <!--v-col cols="12" md="2">
            <v-toolbar dense shaped color="#002245">
              <v-toolbar-title style="color:#ffffff">
                <h6>OPCIONES</h6>
              </v-toolbar-title>
      
              <v-btn class="mx-2" fab dark x-small color="#EE680B" @click="imprimirKardex()" style="float: left"
                title="VER KARDEX">
                <v-icon dark> mdi-printer-outline </v-icon>
              </v-btn>

              
            </v-toolbar>
          </v-col-->
        </v-row>
      </v-card-text>
    </v-card>

    <div class="text-center">
      <v-snackbar v-model="snackbarOK" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
        <strong>{{ mensajeSnackbar }}</strong>


        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarOK = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
    </div>
    <div class="text-center">

      <v-snackbar v-model="snackbarError" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
        <strong>{{ mensajeSnackbar }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarError = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
    </div>

    <div class="text-center">

      <v-snackbar v-model="snackbarError1" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
        <strong>{{ mensajeSnackbarHorario }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarError1 = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
    </div>
    <div class="text-center">

      <v-snackbar v-model="snackbarError2" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
        <strong>{{ mensajeSnackbarGrupoLleno }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarError2 = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>

      <v-snackbar v-model="snackbarError3" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
        <strong>{{ mensajeSnackbarNivel }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarError3 = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
    </div>

  </v-card>
</template>
<script>
import axios from "axios"
import VueHtml2pdf from 'vue-html2pdf'
export default {
  data() {
    return {
      fechaHoy: "",
      fechaEntrega: "",
      mat: "",
      pat: "",
      id_estudiante: "",
      num_documento: "",
      paterno: "",
      materno: "",
      nombres: " ",
      nombreCompleto: "",
      datosCarrera: [],
      idPlanestudio: "",
      idCarrera:"",
      carrera: "",
      gestion: "",
      idGestion: "",
      datosOfertaMaterias: [],
      idMateria: "",
      detalleModal: 0,
      datosCantidadEstGrupo: [],
      datosGruposInscripcion: [],
      idTurno: "",
      datosTurno: [],
      turno: "",
      idGrupoDocente: "",
      idTipoModalidad: 1,
      modalidad: "",
      paralelo: "",
      capacidad: "",
      tipoGrupo: "",
      idNivel: "",
      idUsuario: 6,
      idPlanEconomico: "",
      yaInscrito: false,
      cantidadMaximaMaterias: 7,
      datosGruposPreInscripcion: [],    

      carreraModal:0,
      horarioModal: 0,
      datosHorario: [],
      idFranjaHoraria: "",
      idDia: "",
      cantAct: "",
     
      kardexModal: 0,
      datosDocumentos: [],
      choquecant: 0,
      search: "",
      inpNum: "",
      id_docente: "",
      tipodocente: "",
      searchDocente: "",
      selectGenero: "",
      datosGenero: ["FEMENINO", "MASCULINO"],
      auxmat: "",
      auxpat: "",
      uniest: "",
      headersCarrera: [

        { text: "CARRERA", value: "carre", sortable: true, class: 'my-header-style' },
       // { text: "OPCIONES", value: "actions", sortable: false },
      ],
      datosKardex: [],
    
      est: "",
      elModal: 0,      
    

      snackbarOK: false,
      mensajeSnackbar: "",
      mensajeSnackbarGrupoLleno: "GRUPO LLENO",
      mensajeSnackbarNivel: "AÚN TIENE MATERIAS DE NIVEL INFERIOR",
      mensajeSnackbarHorario: 'CHOQUE DE HORARIO',
      mensajeSnackbarCantidadMaximaMaterias: 'CANTIDAD MAXIMA DE MATERIAS TOMADAS',
      snackbarError: false,
      snackbarError1: false,
      snackbarError2: false,
      snackbarError3: false,
      mensajeError: "",

      timeout: 2000,

      alert: { show: false, message: "" },
      alertdocumento: { show: false, message: "" },
                               
      headersKardex: [
        { text: "GESTION", value: "gest", sortable: true },
        { text: "CRED", value: "cred", sortable: true },
        { text: "MATERIA", value: "mate", sortable: true },
        { text: "GRUPO",value: "paralel", sortable: true },
        { text: "1P", value: "p1", sortable: true },
        { text: "2P", value: "p2", sortable: false },
        { text: "3P", value: "p3", sortable: true },
        { text: "EX FINAL", value: "exfin", sortable: false },
        { text: "2DA INST", value: "seginst", sortable: true },
        { text: "MESA", value: "mesa", sortable: false },
        { text: "GRACIA", value: "graci", sortable: true },
        { text: "NOTA FINAL", value: "notafin", sortable: true },
        { text: "ESTADO", value: "estado", sortable: false },
        { text: "OBSERVACIONES", value: "observac", sortable: true },
      ],

      user: {},
      usuario: "",
      id_sede: "",
      nomus: "",
      patus: "",
      matus: "",
      id_documento: "",
      datosTipoDocumento: "",
      unicodigo:"",
    

    };
  },
  created: function () {
    this.user = JSON.parse(sessionStorage.getItem("session"));
    this.usuario = this.user.personal;
    this.id_sede = this.user.id_sede;
    this.nombreCompleto = this.user.nombres + ' ' + this.user.paterno + ' ' + this.user.materno;
    this.paterno = this.user.paterno;
    this.materno = this.user.materno;
    this.nombres=this.user.nombres;
    this.unicodigo = this.user.unico;



  },
  computed: {},
  components: {
    VueHtml2pdf,

  },

  methods: {      
  
    seleccionarCarrera(item) {
      this.carrera = item.carre;
      this.idCarrera = item.idcar;
      this.idPlanestudio = item.idplan;
      this.carreraModal = false;
      this.listarKardex(this.unicodigo,this.idCarrera,this.id_sede);
    },
    showCarrera() {     
      this.carreraModal = true;
      this.listarCarrera(this.unicodigo);
    },
    closeCarrera() {
      this.carreraModal = false;
    },
    async listarCarrera(unicodigo) {
      let me = this;
      await axios
        .get("/estudiante/listarcarreraestu/" + this.unicodigo + "," + this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosCarrera = [];

          } else {

            me.datosCarrera = response.data.resultado;
          }
        })
        .catch(function (error) {

        });
    },
    getColor(insc) {
      if (insc == 'LIBRE') return 'green'
      else return '#868582'
    },
    getColorKardex(insc) {
      if (insc == 'APROBADO') return 'green'
      else return 'red'
    },
    getColorGrupos(insc) {
      if (insc == 'TEORICO') return 'light-blue accent-2'
      else return 'orange accent-2'
    },
          
   
   
    async listarKardex(unicodigo,idCarrera,id_sede) {
      let me = this;
      await axios
        .get("/estudiante/kardex/" + this.unicodigo + "," + this.idPlanestudio+ "," + this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosKardex = [];

          } else {

            me.datosKardex = response.data.resultado;
          }
        })
        .catch(function (error) {

        });
    },
       

    imprimirKardex() {
      this.$refs.html2Pdf.generatePdf();
   },      

    showKardex() {
      this.kardexModal = true;

    },
    closeKardex() {
      this.kardexModal = false;
    },
  },
};
</script>
<style>
   .page-number {
     position: absolute;
     bottom: 10px;
     right: 10px;
     font-size: 10px;
     color: #333;
   }
   .my-header-style {
     background: #F0F4C3;
    
   }
   .my-header-style2 {
    background: #FFECB3;
   
  }
   </style>